import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TextHeaderComponent } from './components/text-header/text-header.component';
import {  MatTooltipModule } from '@angular/material/tooltip';
@NgModule({
    imports: [
        CommonModule,
        MatTooltipModule,
    ],
    declarations: [
        TextHeaderComponent
    ],
    exports: [
        TextHeaderComponent
    ],
})
export class TextHeaderModule {}
